<template>
  <div class="text-start p-5">
    <div
      v-for="(item, index) in teamInfo"
      :key="index"
      class="bg-primary text-white p-3 fs-5 my-2 rounded row"
    >
      <div class="col-12 col-sm-9">
        شما توسط
        {{ item.team_user.name }}
        به تیم
        {{ item.team_user.name }}
        دعوت شده‌اید. ایا این درخواست را تایید میکنید؟
      </div>
      <div class="col-12 col-sm-3 m-sm-0 mt-2">
        <button
          class="btn btn-warning w-100"
          @click="confirmMembership(item.team_user.id)"
          :disabled="btnDisabled"
        >
          قبول عضویت
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ArefApi from "../../../../libs/api.js";
import utils from "../../../../libs/utils";
export default {
  props: {
    teamInfo: {
      type: Object,
    },
  },
  emits: {
    reloadPage: Function,
  },
  data() {
    return {
      btnDisabled: false,
    };
  },
  created() {
    this.arefApi = new ArefApi(this);
    this.utils = new utils();
  },
  methods: {
    confirmMembership(team_user_id) {
      this.btnDisabled = true;
      this.arefApi
        .verifymembership(team_user_id)
        .then(() => {
          this.$emit("reloadPage");
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        })
        .finally(() => {
          this.btnDisabled = true;
        });
    },
  },
};
</script>